export const ANGLE_PROP = 'angle';
export const LOCKED_PROP = 'locked';
export const LOCATION_PROP = 'location';
export const SHADOW_COLOR_PROP = 'shadowColor';
export const SHADOW_BLUR_PROP = 'shadowBlur';
export const SHADOW_OFFSET_PROP = 'shadowOffset';
export const IS_SIDEBAR_TYPE_PROP = 'isSidebarType';
export const SIZE_PROP = 'size';
export const BACKGROUND_COLOR_PROP = 'background';
export const TEXT_FONT_PROP = 'font';
export const TEXT_PROP = 'text';
export const TEXT_COLOR_PROP = 'textColor';
export const LAYER_NAME_PROP = 'layerName';
export const Z_ORDER_PROP = 'zOrder';
export const TEXT_ALIGNMENT_PROP = 'textAlignment';
export const GEOMETRY_STRING_PROP = 'geometry';
export const BORDER_COLOR_PROP = 'borderColor';
export const BORDER_WIDTH_PROP = 'borderWidth';
export const BORDER_STYLE_PROP = 'borderStyle';
export const TEXT_HIGHLIGHT_COLOR_PROP = 'textHighlightColor';
export const EXPANDED_PROP = 'expanded';
export const GROUP_TITLE_PROP = 'groupTitle';
export const GROUP_DESCRIPTION_PROP = 'groupDescription';
export const SIDEBAR_PORT_ID = 'sidebarPort';
export const VIRTUAL_SIDEBAR_PORT_ID = 'virtualSidebarPort';
export const FIXED_POSITION_PROP = 'fixedPosition';
export const ATTACHED_TO_PROP = 'ATTACHED_TO';
export const EMOJI_PROP = 'emoji';
